import React from 'react';
import { View } from '@upstox/upstox-ui';

const ModalBody: React.FC = ({ children }) => <View padding="xlarge">{ children }</View>;

export default ModalBody;
